import React, { useState } from 'react'
import { addressRegex } from 'utils/regex'

export const initialProducerData = {
    agreementName: "",
    fullLegalName: "",
    name: "",
    address: "",
    producerName: "",
    producerAddress: "",
    services: "",
    trackName: "",
    approvalProcess: "",
    workflow: "",
    deliveryMethod:"",
    deadline: "",
    fee: "",
    masterRoyalty: "",
    recoupabilityClause: "",
    credit: "",
    accountingType: "",
    accountingCost: "",
    accountingDispute: "",
    remedies: "",
    clauses: [],
}

export const initialSideArtistData = {
    agreementName: "",
    fullLegalName: "",
    name: "",
    address: "",
    sideArtistFullLegalName: "",
    sideArtistName: "",
    sideArtistAddress: "",
    services: "",
    otherServices: "",
    project: "",
    feeType: "",
    amount: "",
    royalty: "",
    credit: "",
    royaltyPaymentTimeline: "",
    royaltyThreshold: "",
    noticePeriod: "",
    approvalTime:"",
    labelWavier: "",
    indemnification: "",
    notice: "",
    terminations: "",
    law: "",
    currencySymbol: "",
    effectiveDate: "",
    labelName: "",
    labelAddress: "",
    labelSideArtistName: "",
    labelSideArtistAddress: "",
    labelPrimaryArtistName: "",
    grantRights: "",
    additionalObligations: "",
    rights: "",
    representations: "",
    jurisdiction: "",
    clauses: []
}

export const initialPublishingData = {
  agreementName: "",
  fullLegalName: "",
  name: "",
  address: "",
  artistPublisherName: "",
  artistIdentificationNumber: "",
  artistPublisherAddress: "",
  share: "",
  coWriters: [{
  coWriterFullLegalName: "",
  coWriterName: "",
  coWriterAddress: "",
  publisherName: "",
  identificationNumber: "",
  publisherAddress: "",
  cowriterShare: ""
}],
  disputeSettlement: "",
  controlledComposition: "",
  satutoryRequirement: "",
  approvalTimeframe: "",
}

export const initialArtworkData = {
    agreementName: "",
    fullLegalName: "",
    name: "",
    address: "",
    artworkCreatorName: "",
    artworkCreatorAddress: "",
    musicRelaseName: "",
    artWorkDescription: "",
    artworkFee: "",
    paymentStructure: "",
    deliveryFormat: "",
    deliveryDate: "",
    revisonRound: "",
    additionalCharges: "",
    days: "",
    law: "",
    warrenties: "",
    currencySymbol: "",
    clauses: [
      {copyright: "", isChecked: true, value: ""},
      {revisions: "", isChecked: true, value: "", metaData: {revisionRound: "", additionalCharges: ""}},
      {warrantiesandrepresentations: "", isChecked: true, value: "", metaData: {warrenties: ""}},
      {terminations: "", isChecked: true, value: "", metaData: {days: "", }},
      {governingLaw: "", isChecked: true, value: "", metaData: {law: ""}},
    ]
}

export const initialMusicVideoData = {
    agreementName: "",
    fullLegalName: "",
    name: "",
    address: "",
    director: "",
    bussinessAddress: "",
    realeaseTitle: "",
    scopeProduction: "",
    musicVideoFee: "",
    paymentSchedule: "",
    paymentTerms: "",
    videoFormat: "",
    deliveryDate: "",
    jurisdiction: "",
    days: "",
    disputeSettlement: "",
    clauses: [],
    governmentlaw: "",
    termination: "",
}

export const initialRemixData = {
    agreementName: "",
    fullLegalName: "",
    name: "",
    address: "",
    remixerFullLegalName: "",
    remixerName: "",
    remixerAddress: "",
    releaseName: "",
    editNumber: "",
    bearingTheCost: "",
    remixAudioFormat: "",
    remixFee: "",
    splitPercentage: "",
    remixCredit: "",
    deadline: "",
    clauses: [],
    termination: "",
    remedies: "",
}



